import { Text, TypographyPage } from 'ui';

export default {
  letters: {
    e: {
      text: 'ENTJs are adept at socializing, often taking the liaising role in both formal and casual meetings and conversations',
    },
    n: {
      text: 'All ENTJs like to have clear and large goals to strive for. This is one reason that many ENTJs are particularly career-focused and tend to be high achieving',
    },
    t: {
      text: 'ETNJs prioritize rational, objective, and logical information above feelings and emotions',
    },
    j: {
      text: 'Most ENTJs are rigorous planners and organizers, often employing multiple diaries to keep track of their various engagements',
    },
  },
  persons: [
    {
      slug: 'carrey',
      name: 'Jim Carrey',
    },
    {
      slug: 'thatcher',
      name: 'Margaret Thatcher',
    },
    {
      slug: 'jobs',
      name: 'Steve Jobs',
    },
  ],
  advantages: ['Forthright', 'Highly Social', 'Aspirational', 'Confident'],
  disadvantages: [
    'Overly dominant',
    'Too persnickety',
    'Unfairly dismissive',
    'Poor handling of emotions',
  ],
  aboutUsCards: [
    {
      color: 'orange',
      title: 'ENTJs as Parents',
      text: 'ENTJs as parents can be rather strict at times, but they will always be loyal and giving toward their children. An ENTJ parent will push their child hard in terms of hobbies and achievements while doing their best to provide their child with whatever they need to forge a strong path forward.',
    },
    {
      color: 'red',
      title: 'ENTJs as Partners',
      text: 'Partnering with a healthy ENTJ can be a lot of fun, since they are action-focused people who will always be looking for the next source of excitement as a couple. That being said, if you like a more laid-back relationship, then an ENTJ may not be the ideal partner for you. Due to their high standards for themselves and others, they can take a lot of energy and maintenance.',
    },
    {
      color: 'mint',
      title: 'ENTJs as Friends',
      text: 'As a friend, the ENTJ is an excellent advisor. Typically, due to their broad experience, they know a little something about everything and are more than willing to share with you. ENTJ friends are also fantastic at encouraging you to attend events or try new hobbies. An ENTJ can be a truly valuable friend to have.',
    },
  ],
  aboutTypeDescription:
    'Characterized by extraverted, intuitive, thinking, and judging traits, strong leadership skills come naturally to the ENTJ personality type. As roughly 8-9% of the population, the ENTJ is neither rare nor common, though one who makes the most of their traits will stand out as someone to turn to when important decisions need to be made.',
  aboutTypeTextContent: (
    <TypographyPage dense>
      <Text>
        The ENTJ personality type is sometimes nicknamed the Commander, the
        Visionary, the CEO, the Field Marshal, or the Assertive Leader. If
        you’ve discovered that this is your type, feel free to choose the
        personality type nickname that best suits your characteristics or come
        up with your own. Remember, not all ENTJs are the same!
      </Text>
      <Text>
        An ENTJ loves to spearhead the decision-making process and is often the
        first to take action in a stressful situation. Their assertive nature is
        one of the qualities that makes them excellent leaders. Yet, this
        quality expands to their individual lives as well; an ENTJ will be
        driven in taking actions that bring them closer to achieving their
        personal goals.
      </Text>
    </TypographyPage>
  ),
};
